import {EddlMergedAbstract} from '@app/services/analytics/EDDL/events/eddl-merged.abstract';
import {EddlAdobeTrackingDataProductData} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';

export class EddlProductViewEvent extends EddlMergedAbstract {
  static readonly type = 'EddlProductViewEvent';
  products?: EddlAdobeTrackingDataProductData[]
}
